export default __webpack_public_path__ + "static/media/profile-user.78257551.png";